// Module
var code = "<div ref=\"map\"></div>";
// Exports
module.exports = code;